@import ../../../styles/helpers

.chart
    width: auto
    height: 274px
    margin-left: -35px
    margin-bottom: -10px